// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const rampart = defineModel({
  id: "rampart",
  batchId: "future",
  name: "Rampart",
  tags: ["building","rampart","low-poly","age-of-mcp","future","military"],
  summary: "An earth-and-stone rampart — a raised defensive embankment.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.06, 0.12, 1.06), color: "#5a5a5a", position: [0, 0.06, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.06, 0.12, 1.06), color: "#5a5a5a", position: [0, 0.06, 0] },
      { geometry: new THREE.BoxGeometry(1, 0.4, 0.34), color: "#8a8275", position: [0, 0.34, 0] },
      { geometry: new THREE.BoxGeometry(1.04, 0.05, 0.38), color: "#665f54", position: [0, 0.42, 0] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.06, 0.12, 1.06), color: "#5a5a5a", position: [0, 0.06, 0] },
      { geometry: new THREE.BoxGeometry(1, 0.8, 0.34), color: "#8a8275", position: [0, 0.54, 0] },
      { geometry: new THREE.BoxGeometry(1.04, 0.05, 0.38), color: "#665f54", position: [0, 0.7, 0] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1, 0.85, 0.34), color: "#8a8275", position: [0, 0.565, 0] },
      { geometry: new THREE.BoxGeometry(1.04, 0.05, 0.38), color: "#665f54", position: [0, 0.735, 0] },
      { geometry: new THREE.BoxGeometry(1, 0.08, 0.34), color: "#8a8275", position: [0, 1.03, 0] },
      { geometry: new THREE.BoxGeometry(1, 0.04, 0.14), color: "#7a7064", position: [0, 0.93, -0.22] },
      { geometry: new THREE.BoxGeometry(0.16, 0.16, 0.12), color: "#696156", position: [-0.4, 1.15, 0.11] },
      { geometry: new THREE.BoxGeometry(0.16, 0.16, 0.12), color: "#696156", position: [-0.2, 1.15, 0.11] },
      { geometry: new THREE.BoxGeometry(0.16, 0.16, 0.12), color: "#696156", position: [0, 1.15, 0.11] },
      { geometry: new THREE.BoxGeometry(0.16, 0.16, 0.12), color: "#696156", position: [0.2, 1.15, 0.11] },
      { geometry: new THREE.BoxGeometry(0.16, 0.16, 0.12), color: "#696156", position: [0.4, 1.15, 0.11] },
    ] },
  ],
  animations: [],
});
